
export type ResourceType =
    'TYPE_GOAL_COMMENT' |
    'TYPE_GOAL_COMMENT_REACTION' |
    'TYPE_REVIEW_ASSIGNED' |
    'TYPE_REVIEW_COMPLETED' |
    'TYPE_REVIEW_PATIALLY_COMPLETED' |
    'TYPE_TRAINING_ASSIGNED' |
    'TYPE_REVIEWER_COMMENT' |
    'TYPE_EMPLOYEE_PENDING_DOCUMENT_SIGNATURE' |
    'TYPE_ADMIN_PENDING_DOCUMENT_SIGNATURE' |
    'TYPE_DOCUMENT_SIGNED_BY_EMPLOYEE' |
    'TYPE_DOCUMENT_SIGNED_BY_ADMIN' |
    'TYPE_LEAVE_REQUEST_REMOVED' |
    'TYPE_EMPLOYEE_TRAINING_CERTIFICATE_READY' |
    'TYPE_EMPLOYEE_PENDING_CERTIFICATE_SIGNATURE';

export function getTypeLabel(resourceType: ResourceType): string {
    switch (resourceType) {
        case 'TYPE_GOAL_COMMENT':
        case 'TYPE_GOAL_COMMENT_REACTION':
            return 'Goal';
        case 'TYPE_REVIEW_ASSIGNED':
            return 'Review Assigned';
        case 'TYPE_REVIEW_COMPLETED':
            return 'Review Completed';
        case 'TYPE_REVIEW_PATIALLY_COMPLETED':
            return 'A review has been signed';
        case 'TYPE_TRAINING_ASSIGNED':
            return 'Training Assigned';
        case 'TYPE_REVIEWER_COMMENT':
            return 'Reviewer Commented';
        case 'TYPE_EMPLOYEE_PENDING_DOCUMENT_SIGNATURE':
        case 'TYPE_ADMIN_PENDING_DOCUMENT_SIGNATURE':
            return 'Pending Document Signature';
        case 'TYPE_EMPLOYEE_PENDING_CERTIFICATE_SIGNATURE':
            return 'Pending Certificate Signature';
        case 'TYPE_DOCUMENT_SIGNED_BY_EMPLOYEE':
            return 'Document Signed by Employee';
        case 'TYPE_DOCUMENT_SIGNED_BY_ADMIN':
            return 'Document Signed by Company';
        case 'TYPE_LEAVE_REQUEST_REMOVED':
            return 'Time Off Request Removed';
        case 'TYPE_EMPLOYEE_TRAINING_CERTIFICATE_READY':
            return 'Training Certificate Ready';
        default:
            return 'Unknown';
    }
}



export type UserNotification = {
    id: number;
    user_id: number;
    resource_type: ResourceType;
    resource_id: number;
    message: string;
    app_url: string;
    did_read: boolean;
    created_at: string;
    updated_at: string;
    description: string;
    title: string;
}